import * as React from 'react'
import {
  Theme,
  createStyles,
  WithStyles,
  withStyles
} from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import AppBar from '@material-ui/core/AppBar'
import CheckCircle from '@material-ui/icons/CheckCircle'
import {
  IChecklist,
  IChecklistField,
  IChecklistGroup,
  IChecklistRenderProps,
  IPhoto
} from '../../models/Checklist'
import { isLocalImage } from '../../data_sources/imagestorage/imageStorage'
import { TabsContext } from '../common/Tabs'
import QuestionGroup from '../checklists/QuestionGroup'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../OneplaceLibraryProvider'

const styles = (theme: Theme) =>
  createStyles({
    tabWarningIcon: {
      width: 20,
      height: 20,
      marginLeft: 6,
      color: theme.palette.secondary.main
    },
    tabLight: {
      background: theme.palette.primary.light,
      color: '#fff'
    }
  })

export interface ITicketChecklistProps
  extends WithStyles<typeof styles>,
    IOneplaceLibraryContextProp {
  checklist: IChecklist
  renderProps: IChecklistRenderProps
  onChecklistChange: (groupIndex: number, fieldId: number) => void
  validateConditionalQuestion: (
    newValue: string,
    question: IChecklistField | null
  ) => void

  // conditional questions need refresh
  questionsNeedRefresh: boolean
  disableTabs?: boolean

  refreshFormulaQuestions: (inputQuestion: IChecklistField) => void
}

export interface ITicketChecklistState {
  selectedTabIdx: number
  selectedGroupIdx: number
  disableTabs: boolean
}

export const TicketChecklistTab = withStyles(styles)(
  withOneplaceLibraryContext(
    // eslint-disable-next-line react/display-name
    class extends React.Component<
      ITicketChecklistProps,
      ITicketChecklistState
    > {
      timer: any = null
      groupsToShow: IChecklistGroup[] = []

      constructor(props: any) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.nextTab = this.nextTab.bind(this)
        this.prevousTab = this.prevousTab.bind(this)
        this.groupsToShow = this.props.checklist.groups.filter(
          (_group, index) => {
            return this.props.renderProps.groups[index].showTab
          }
        )
        this.state = {
          selectedTabIdx: 0,
          selectedGroupIdx: 0,
          disableTabs: this.props.disableTabs ? this.props.disableTabs : false
        }
      }

      componentWillReceiveProps = (nextProps: ITicketChecklistProps) => {
        this.setState({
          disableTabs: nextProps.disableTabs ? nextProps.disableTabs : false
        })
      }

      handleChange(_event: any, value: any) {
        let selectedGroupOffset: number
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        selectedGroupOffset = value
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const selectedGroup = this.groupsToShow[value]
        selectedGroupOffset = this.props.checklist.groups.findIndex((group) => {
          return group.id == selectedGroup.id
        })
        this.setState({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          selectedTabIdx: value,
          selectedGroupIdx: selectedGroupOffset
        })
      }

      nextTab() {
        if (
          this.state.selectedTabIdx <
          this.props.checklist.groups.length - 1
        ) {
          let selectedGroupOffset: number
          selectedGroupOffset = this.state.selectedTabIdx + 1
          const selectedGroup = this.groupsToShow[this.state.selectedTabIdx + 1]
          selectedGroupOffset = this.props.checklist.groups.findIndex(
            (group) => {
              return group.id == selectedGroup.id
            }
          )
          this.setState({
            selectedTabIdx: this.state.selectedTabIdx + 1,
            selectedGroupIdx: selectedGroupOffset
          })
        }
      }

      prevousTab() {
        if (this.state.selectedTabIdx > 0) {
          let selectedGroupOffset: number
          selectedGroupOffset = this.state.selectedTabIdx - 1
          const selectedGroup = this.groupsToShow[this.state.selectedTabIdx - 1]
          selectedGroupOffset = this.props.checklist.groups.findIndex(
            (group) => {
              return group.id === selectedGroup.id
            }
          )
          this.setState({
            selectedTabIdx: this.state.selectedTabIdx - 1,
            selectedGroupIdx: selectedGroupOffset
          })
        }
      }

      onDeletePhoto = (photo: IPhoto) => {
        if (!isLocalImage(photo.url) && photo.id) {
          let deletedPhotos = this.props.checklist.deletedPhotos
          if (deletedPhotos === null || deletedPhotos === undefined) {
            deletedPhotos = []
            this.props.checklist.deletedPhotos = deletedPhotos
          }
          if (!(photo.id in deletedPhotos)) {
            deletedPhotos.push(photo.id)
          }
        }
      }

      render() {
        this.groupsToShow = this.props.checklist.groups.filter(
          (_group, index) => {
            return this.props.renderProps.groups[index].showTab
          }
        )

        return (
          <React.Fragment>
            <Card>
              <AppBar position='static' className={this.props.classes.tabLight}>
                <Tabs
                  value={this.state.selectedTabIdx}
                  onChange={this.handleChange}
                  variant='scrollable'
                >
                  {this.groupsToShow.map((group, idx) => {
                    // group index is the index in complete groups list
                    // includes show and hidden groups
                    let groupIndex = 0
                    for (
                      let i = 0;
                      i < this.props.checklist.groups.length;
                      i++
                    ) {
                      if (this.props.checklist.groups[i].id == group.id) {
                        groupIndex = i
                        break
                      }
                    }
                    const renderProps =
                      this.props.renderProps.groups[groupIndex]
                    const label = (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {group.label}
                        {!renderProps.incompleteFields && (
                          <CheckCircle
                            className={this.props.classes.tabWarningIcon}
                          />
                        )}
                      </div>
                    )
                    return (
                      <Tab
                        key={idx}
                        label={label}
                        disabled={this.state.disableTabs}
                      />
                    )
                  })}
                </Tabs>
              </AppBar>
            </Card>
            <TabsContext.Provider
              value={{
                nextTab: this.nextTab,
                previousTab: this.prevousTab,
                notifyUpdate: () => null,
                nextTabDisabled:
                  this.state.selectedTabIdx == this.groupsToShow.length - 1,
                previousTabDisabled: this.state.selectedTabIdx == 0
              }}
            >
              <QuestionGroup
                groupIndex={this.state.selectedGroupIdx}
                group={this.props.checklist.groups[this.state.selectedGroupIdx]}
                renderProps={
                  this.props.renderProps.groups[this.state.selectedGroupIdx]
                }
                onFieldChange={this.props.onChecklistChange}
                onTicketPreset={() =>
                  alert(
                    'Ticket presets on ticket checklists not currently supported.'
                  )
                }
                validateConditionalQuestion={
                  this.props.validateConditionalQuestion
                }
                questionsNeedRefresh={this.props.questionsNeedRefresh}
                dateTimeFormat={
                  this.props.ctx.client.getCapabilities().dateTimeFormat
                }
                dateFormat={this.props.ctx.client.getCapabilities().dateFormat}
                fullName={this.props.ctx.client.getCapabilities().username}
                hideGroupPhotos={this.props.checklist.hideGroupPhotos}
                onDeletePhoto={this.onDeletePhoto}
                allowSavedPhotoDeletion={true}
                allowPhotosFromGallery={
                  this.props.ctx.client.getCapabilities().usePhotoGallery
                }
                refreshFormulaQuestions={this.props.refreshFormulaQuestions}
              />
            </TabsContext.Provider>
          </React.Fragment>
        )
      }
    }
  )
)
